import React, { FC } from "react";
import { ApolloUserAuth } from "../shared/hoc/Apollo";

const PrivateRoutes: FC<any> = props => (
  <ApolloUserAuth>{props.children}</ApolloUserAuth>
);

export default PrivateRoutes;
try {
    // @ts-ignore
    privateRoutes.displayName = "privateRoutes";
    // @ts-ignore
    privateRoutes.__docgenInfo = { "description": "", "displayName": "privateRoutes", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/routes/privateRoutes.tsx#privateRoutes"] = { docgenInfo: privateRoutes.__docgenInfo, name: "privateRoutes", path: "src/routes/privateRoutes.tsx#privateRoutes" };
}
catch (__react_docgen_typescript_loader_error) { }